import { styled } from 'linaria/lib/react';

export const StyledWrap = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;
